import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Link,
  Paper
} from "@mui/material";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { motion } from "framer-motion";

const MotionTypography = motion(Typography);

const ThankYouPage = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        p: 4,
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <MotionTypography
        variant="h4"
        sx={{
          fontWeight: "bold",
          color: "#333",
          textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
          textAlign: "center",
        }}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        Thank You! 🎉
      </MotionTypography>
      <Typography
        sx={{ textWrap: "wrap", textAlign: "center", maxWidth: { xs: "95%", md: "50%" } }}
      >
        Your submission has been received successfully. We appreciate your interest and will be in touch with you soon.
      </Typography>
      <Typography
        sx={{ textWrap: "wrap", textAlign: "center", maxWidth: { xs: "95%", md: "50%" }, mt: 2 }}
      >
        One of our team members will contact you within 24 hours. Or you can contact us at <Link href="mailto:help.aasthacomputers@gmail.com">help.aasthacomputers@gmail.com</Link> for further assistance.
      </Typography>
      <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleHomeClick}
          sx={{
            background: "#333",
            color: "#fff",
          }}
        >
          Go to Home
        </Button>
        <Button
          variant="contained"
          component={RouterLink}
          to="/"
          sx={{
            background: "#333",
            color: "#fff",
          }}
        >
          Browse Courses
        </Button>
      </Stack>

      <Paper
        sx={{
          mt: 4,
          p: 3,
          backgroundColor: "#fff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          borderRadius: "16px",
        }}
      >
        <Typography variant="h6" sx={{ mb: 1, textAlign: "center" }}>
          Contact Information
        </Typography>
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          <strong>Email:</strong> help.aasthacomputers@gmail.com
        </Typography>
        <Typography variant="body1" sx={{ textAlign: "center" }}>
          <strong>Phone:</strong> +91-99 280 12909 | +91-99 280 04669
        </Typography>
      </Paper>
    </Box>
  );
};

export default ThankYouPage;
